// oxlint-disable-next-line cian-eslint-compat/no-restricted-paths
import { getCookie } from '../../../browser/utils/cookie';
import { SHOWN_SALES_START_ONBOARDING_COOKIE_KEY } from '../../constants/salesStartOnboarding';

export function getSalesStartOnboardingCookie() {
  const cookie = getCookie(SHOWN_SALES_START_ONBOARDING_COOKIE_KEY);

  return Number(cookie) || 0;
}
